import { render, staticRenderFns } from "./PopularSeries.vue?vue&type=template&id=3ad3c4b9&scoped=true&"
import script from "./PopularSeries.vue?vue&type=script&lang=js&"
export * from "./PopularSeries.vue?vue&type=script&lang=js&"
import style0 from "./PopularSeries.vue?vue&type=style&index=0&id=3ad3c4b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad3c4b9",
  null
  
)

export default component.exports